<template>
  <BLayoutExpansion :key="data.position" class="my-4">
    <template #header>
      <v-layout row align-center class="ma-0">
        <b>Часть {{ data.position }}</b>
        <v-spacer />
        <v-tooltip v-if="isCreate" left>
          <template #activator="{ on }">
            <v-btn icon :disabled="partsCount <= 1" @click.stop="() => $emit('remove', data.position)" v-on="on">
              <v-icon v-text="'mdi-close'" />
            </v-btn>
          </template>
          <span>Удалить часть {{ data.position }}</span>
        </v-tooltip>
      </v-layout>
    </template>
    <v-row class="d-flex justify-space-between mb-6 bg-surface-variant">
      <template v-if="isCreate">
        <v-col dense cols="6" fluid>
          <v-row dense>
            <v-col>
              <StorageAutocomplete
                v-model="data.lk_kim_storage_id"
                label="Выберите хранилище КИМ"
                data-vv-as="Хранилище КИМ"
                :exclude="excludedItemsKims"
                :lk-publication-id="lkPublicationId"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <StorageAutocomplete
                v-model="data.lk_krit_storage_id"
                label="Выберите хранилище критериев"
                data-vv-as="Хранилище критериев"
                :exclude="excludedItemsCrits"
                :lk-publication-id="lkPublicationId"
              />
            </v-col>
          </v-row>
        </v-col>
      </template>
      <template v-else>
        <v-col dense cols="6" fluid>
          <v-row dense>
            <v-text-field
              :value="data.lk_kim_storage_id"
              :loading="skeleton"
              label="ID хранилища КИМ"
              variant="regular"
              readonly
            />
            <v-spacer />
            <v-text-field
              :value="data.lk_krit_storage_id"
              :loading="skeleton"
              label="ID хранилища критериев"
              variant="regular"
              readonly
            />
          </v-row>

          <v-row dense>
            <v-col>
              <BFileUpload
                accept=".xlsx"
                label="Раскладка КИМ (XLSX)"
                :disabled="!hasVariants"
                @change="kimsFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!hasVariants || !kimsFile"
                @click="onUploadFile(kimsFile, 'VPR_USERS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <BFileUpload
                accept=".zip"
                label="Критерии оценивания (.zip)"
                :disabled="!hasVariants"
                @change="kritsFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!hasVariants || !kritsFile"
                @click="onUploadFile(kritsFile, 'VPR_VARIANTS_CRITERIA')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <BFileUpload
                accept=".zip"
                label="Варианты (.zip)"
                @change="variantsFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!variantsFile"
                @click="onUploadFile(variantsFile, 'VPR_VARIANTS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <BFileUpload
                accept=".csv"
                :disabled="!hasVariants"
                label="Монтажный лист (.csv)"
                @change="guidTasksFile = $event"
              />
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!hasVariants || !guidTasksFile"
                @click="onUploadFile(guidTasksFile, 'VPR_GUID_TASKS')"
                v-text="'Загрузить'"
              />
            </v-col>
          </v-row>
          <v-row>
            <span v-if="data.exc_info !== null" class="red--text">
              {{ data.exc_info }}
            </span>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-row>
            <v-col>
              Сформировано комплектов
            </v-col>
            <v-col>
              {{ data.generated_users || 0 }} /
              {{ data.target_users || 0 }}
            </v-col>
          </v-row>

          <v-progress-linear
            class="LKMunMehCardProgress__progress"
            :value="
              ((data.generated_users || 0) /
                (data.target_users || 1)) *
                100
            "
            height="12"
          />

          <v-row class="mt-2" dense>
            <v-col cols="auto">
              <v-btn
                depressed
                block
                :disabled="generateKimsDisabled"
                @click="onGenerateKims"
                v-text="'Сгенерировать КИМы'"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              Экспортировано в ЛК КИМов
            </v-col>
            <v-col v-if="reportKimsTask">
              {{ reportKimsTask.imported }} /
              {{ data.target_users || 0 }}
            </v-col>
          </v-row>

          <v-progress-linear
            class="LKMunMehCardProgress__progress"
            :value="
              ((reportKimsTask ? reportKimsTask.imported : 0) /
                (data.target_users || 1)) *
                100
            "
            height="12"
          />
          <v-row class="mt-2" dense>
            <v-col cols="auto">
              <v-btn
                depressed
                block
                :disabled="!canImport"
                @click="onImportKims('kim')"
                v-text="'Отправить КИМы в ЛК'"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              Экспортировано в ЛК критериев
            </v-col>
            <v-col v-if="reportKritTask">
              {{ reportKritTask.imported }} /
              {{ data.target_users || 0 }}
            </v-col>
          </v-row>

          <v-progress-linear
            class="LKMunMehCardProgress__progress"
            :value="
              ((reportKritTask ? reportKritTask.imported : 0) /
                (data.target_users || 1)) *
                100
            "
            height="12"
          />
          <v-row class="mt-2" dense>
            <v-col cols="auto">
              <v-btn
                depressed
                block
                :disabled="!canImport"
                @click="onImportKims('krit')"
                v-text="'Отправить критерии в ЛК'"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <QrCodesTable
            v-if="data.vpr_publication_part_id"
            ref="qrTable"
            :vpr-publication-part-id="data.vpr_publication_part_id"
            @received="() => hasQrCodes = true"
          />
          <VariantsTable
            v-if="data.vpr_publication_part_id"
            ref="variantsTable"
            class="mt-2"
            :vpr-publication-part-id="data.vpr_publication_part_id"
            @received="() => hasVariants = true"
          />
        </v-col>
      </template>
    </v-row>
    <slot name="save-menu" />
  </BLayoutExpansion>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BFileUpload from '@/components/forms/BFileUpload.vue'
import { createUploadFileModal } from '../utils'
import { VPRPublicationsApi } from '@/api/resources/Collector/VPRPublicationsApi'
import { ImportKimsTasksApi } from '@/api/resources/Collector/VPRPublicationsImportApi'
import StorageAutocomplete from './StorageAutocomplete.vue'
import QrCodesTable from './QrCodesTable.vue'
import VariantsTable from './VariantsTable.vue'

export const createDefaultData = () => ({
  vpr_publication_part_id: null,
  vpr_publication_id: void 0,
  position: 1,
  lk_kim_storage_id: 0,
  lk_krit_storage_id: 0,
  generated_users: 0,
  target_users: 0,
  kim_file_sha1: '',
  krit_file_sha1: '',
  xlsx_file_sha1: '',
})

export default {
  name: 'VPRPublicationsPartForm',
  components: {
    QrCodesTable,
    VariantsTable,
    BLayoutExpansion,
    BFileUpload,
    StorageAutocomplete,
  },
  extends: BLayoutForm,
  props: {
    editable: Boolean,
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
    lkPublicationId: Number,
    parts: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    variantsFile: null,
    kimsFile: null,
    kritsFile: null,
    guidTasksFile: null,

    reportKimsTask: null,
    reportKritTask: null,
    hasQrCodes: false,
    hasVariants: false,
  }),
  computed: {
    partsCount() {
      return this.parts.length
    },
    excludedItemsKims() {
      return this.parts
        .map((el) => {
          if (el.position === this.data.position) {
            return [el.lk_krit_storage_id]
          }
          return [el.lk_kim_storage_id, el.lk_krit_storage_id]
        })
        .flat()
        .filter(Boolean)
    },
    excludedItemsCrits() {
      return this.parts
        .map((el) => {
          if (el.position === this.data.position) {
            return [el.lk_kim_storage_id]
          }
          return [el.lk_kim_storage_id, el.lk_krit_storage_id]
        })
        .flat()
        .filter(Boolean)
    },
    canImport() {
      return (
        this.data.target_users
        && this.data.target_users === this.data.generated_users
      )
    },
    generateKimsDisabled() {
      return !this.hasQrCodes || !this.hasVariants
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        if (this.data.lk_kim_storage_id && this.data.lk_krit_storage_id && !this.isCreate) {
          this.getImportKimsTasks()
        }
      },
    },
  },
  methods: {
    onRefresh() {
      this.$refs.qrTable.onRefresh()
      this.$refs.variantsTable.onRefresh()
    },
    async getImportKimsTasks() {
      try {
        const api = new ImportKimsTasksApi()

        const [kimsReq, kritReq] = await Promise.all([
          api.getImportedKims(this.data.lk_kim_storage_id),
          api.getImportedKims(this.data.lk_krit_storage_id),
        ])

        const kimsItem = kimsReq.data[0]
        const kritItem = kritReq.data[0]

        this.reportKimsTask = kimsItem
        this.reportKritTask = kritItem

        return kimsItem
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
    async onUploadFile(file, taskKey) {
      const updateSha = (sha1) => {
        switch (taskKey) {
          case 'VPR_VARIANTS':
            this.$emit('update-part', {
              ...this.data,
              kim_file_sha1: sha1,
            })
            break
          case 'VPR_VARIANTS_CRITERIA':
            this.$emit('update-part', {
              ...this.data,
              krit_file_sha1: sha1,
            })
            break
          case 'VPR_USERS':
            this.$emit('update-part', {
              ...this.data,
              xlsx_file_sha1: sha1,
            })
            break
          default:
            break
        }
      }
      const propsData = {
        file,
        publicationId: this.data.vpr_publication_id,
        publicationPartId: this.data.vpr_publication_part_id,
        taskKey,
        updateSha,
        on: {
          success: () => {
            this.$emit('refresh')
          },
        },
      }
      const modal = await createUploadFileModal(this, propsData)
      const result = await modal.open()
      if (!result) return

      this.form = {
        ...this.form,
        ...result,
      }
    },
    async onGenerateKims() {
      try {
        const api = new VPRPublicationsApi()
        const { vpr_publication_id, vpr_publication_part_id } = this.data
        const { data } = await api.generateKims(vpr_publication_id, vpr_publication_part_id)
        this.$notice.info(
          'КИМы генерируются. После завершения генерации Вы получите сообщение в разделе уведомления',
        )
        return data
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
    async onImportKims(type) {
      const { lk_kim_storage_id, lk_krit_storage_id } = this.data
      const sId = type === 'kim' ? lk_kim_storage_id : lk_krit_storage_id

      try {
        const api = new ImportKimsTasksApi()
        await api.importKims(this.lkPublicationId, sId)
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
